import React from 'react';
import PropTypes from 'prop-types';

import { Span } from '@sopranodesign/pulse-components';

const StandardScope = ({ content }) => {
  return <Span>{content.value}</Span>;
};

StandardScope.propTypes = {
  content: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  }).isRequired
};

export default StandardScope;
